import React from "react";
import IncidentDashboard from "../IncidentManagement/components/IncidentDashboard";
import { EXTERNAL_EMERGENCY_PREPAREDNESS_INCIDENTS } from "../../constants/modules";
import { fetchIncidentsByDepartment } from "../IncidentManagement/services/service";
import { IncidentDepartmentEnum } from "../../constants/incidents";

const ExternalEmergencyIncident: React.FC = () => (
  <IncidentDashboard
    department={IncidentDepartmentEnum.ExternalEmergencyPreparedness}
    pageTitle="External Emergency Incidents"
    moduleKey={EXTERNAL_EMERGENCY_PREPAREDNESS_INCIDENTS}
    fetchService={fetchIncidentsByDepartment}
  />
);

export default ExternalEmergencyIncident;
